// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__s4fH0","container":"styles_container__xK58k","copyright":"styles_copyright__PDUE8","link":"styles_link__B6wEa"};